<form class="overflow-auto survey">
  <div nz-row [nzGutter]="0">
    <div nz-col nzSm="2" nzMd="2" nzLg="2" nzXl="3">
    </div>
    <div class="content" nz-col nzSm="20" nzMd="20" nzLg="20" nzXl="18">
      <nz-card>
        <div class="flex justify-between">
            <div class="img-logo">
              <img src="./assets/img/logo-projects/Logo.png">
            </div>
            <div class="code">
              <span>
                Mã Phiếu
              </span>
              <input class="input-form-code" />
              <div class="form-code">
                <div>
                  <input *ngFor="let inp of inputCode" type="text" max="1">
                </div>
                <div>
                  <input *ngFor="let inp of inputCode" type="text" max="1">
                </div>

              </div>
            </div>
        </div>
        <div class="description">
          <h4 class="title">
            PHIẾU HỎI DÀNH CHO NGƯỜI KHUYẾT TẬT
          </h4>
          <p class="indent">
            Để thu thập dữ liệu cho quản lý giáo dục người khuyết tật Việt Nam, Mong Ông/ Bà/ Em vui lòng cung cấp thông tin theo các nội dung dưới đây bằng cách <span class="bold">đánh dấu (X) vào • phương án lựa chọn hoặc điền thông tin vào các chỗ (……).</span> Các thông tin chỉ được dùng cho mục đích chăm sóc giáo dục người khuyết tật. Các thông tin cá nhân được bảo mật. Trân trọng cảm ơn sự hợp tác của Ông/ Bà/ Em.
            <br>
            <span class="text-case">
              Trường hợp người khuyết tật không trả lời thì phụ huynh hoặc người giám hộ sẽ cung cấp thông tin các mục A, B, C
            </span>
          </p>
              <h4 class="title second">
                A. Thông tin chung
              </h4>
              <div class="item-form">
                <div nz-row [nzGutter]="[24,24]" >
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'infoProvider'" nzRequired #label>1. Người cung cấp thông tin</nz-form-label>
                      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="isCheckValidate && disabilitySurvey.infoProvider ? '' : 'error'">
                        <nz-radio-group [(ngModel)]="disabilitySurvey.infoProvider" [ngModelOptions]="{standalone :true}">
                          <label nz-radio [nzValue]="1">Người khuyết tật</label>
                          <label nz-radio [nzValue]="2">Phụ huynh/ người giám hộ</label>
                        </nz-radio-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'fullName'"  nzRequired #label>2. Họ và tên người khuyết tật</nz-form-label>
                      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="isCheckValidate && disabilitySurvey.fullName ? '' : 'error'">
                        <input nz-input [(ngModel)]="disabilitySurvey.fullName" [ngModelOptions]="{standalone :true}"/>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="14">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'yearOfBirth'" nzRequired #label>3. Người khuyết tật sinh ngày</nz-form-label>
                      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="isCheckValidate && disabilitySurvey.yearOfBirth ? '' : 'error'" class="date-group">
                        <nz-input-number [(ngModel)]="disabilitySurvey.dayOfBirth" [nzMin]="1" [nzMax]="31" [nzStep]="1" class="date non-error widthcss" [ngModelOptions]="{standalone :true}"></nz-input-number>
                        tháng:
                        <nz-input-number [(ngModel)]="disabilitySurvey.monthOfBirth" [nzMin]="1" [nzMax]="12" [nzStep]="1" class="date non-error" [ngModelOptions]="{standalone :true}"></nz-input-number>
                        năm:
                        <nz-input-number [(ngModel)]="disabilitySurvey.yearOfBirth" [nzMin]="1900" [nzMax]="yearNow" [nzStep]="1" class="date non-error" [ngModelOptions]="{standalone :true}"></nz-input-number>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="10">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'gender'" class="text-right" nzRequired #label>4. Giới tính</nz-form-label>
                      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc">
                        <nz-radio-group [(ngModel)]="disabilitySurvey.gender" [ngModelOptions]="{standalone :true}">
                          <label nz-radio [nzValue]="1">Nam</label>
                          <label nz-radio [nzValue]="0">Nữ</label>
                        </nz-radio-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'folkId'" nzRequired #label>5. Dân tộc</nz-form-label>
                      <nz-form-control>
                        <asc-autocomplete [ascModel]="FolkControl" (ascModelChange)="changeFolk($event)" [placeholder]="'Chọn dân tộc'" [getListAC]="getFolkACFn">
                        </asc-autocomplete>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12"></div>
                  <div nz-col [nzSpan]="24" class="flex">
                    <div>
                      <nz-form-label [nzFor]="'field'">6. Chỗ ở hiện nay</nz-form-label>
                    </div>
                    <div>
                      <div nz-row [nzGutter]="[24,24]">
                        <div nz-col [nzSpan]="8">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'provinceId'" nzRequired #label>Tỉnh/TP</nz-form-label>
                            <nz-form-control [nzSpan]="24" nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="isCheckValidate && disabilitySurvey.provinceId ? '' : 'error'">
                              <asc-autocomplete [ascModel]="ProvinceControl" (ascModelChange)="changeProvince($event)"[placeholder]="'Chọn tỉnh thành'" [getListAC]="getProvinceACFn">
                            </asc-autocomplete>
                            </nz-form-control>
                          </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="8">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'districtId'">quận/huyện</nz-form-label>
                              <asc-autocomplete [ascModel]="DistrictControl" (ascModelChange)="changeDistrict($event)" [placeholder]="'Chọn quận huyện'" [getListAC]="getDistrictACFn"></asc-autocomplete>
                          </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="8">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'wardId'">phường/xã</nz-form-label>
                            <nz-form-control [nzSpan]="24" nzErrorTip="Nhập trường thông tin bắt buộc">
                              <asc-autocomplete [ascModel]="WardControl" (ascModelChange)="changeWard($event)" [placeholder]="'Chọn phường xã'" [getListAC]="getWardACFn"></asc-autocomplete>
                            </nz-form-control>
                          </nz-form-item>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'disDisabilityCertificateType'" nzRequired #label>7. Giấy chứng nhận khuyết tật</nz-form-label>
                        <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc">
                          <nz-radio-group [(ngModel)]="disabilitySurvey.disDisabilityCertificateType" [ngModelOptions]="{standalone :true}">
                            <label nz-radio [nzValue]="1">Không</label>
                            <label nz-radio [nzValue]="0">Có</label>
                          </nz-radio-group>
                        </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'typeOfDisabilityId'" nzRequired #label>8. Dạng tật</nz-form-label>
                        <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="isCheckValidate && disabilitySurvey.typeOfDisabilityId ? '' : 'error'">
                        <asc-autocomplete  [ascModel]="disTypeOfDisabilitysControl"
                          (ascModelChange)="changeDisTypeOfDisabilitysACFn($event)" placeholder="Chọn dạng tật"
                          [getListAC]="getDisTypeOfDisabilitysACFn">
                        </asc-autocomplete>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'field'" class="text-right">Nhập khi chọn là "khác"</nz-form-label>
                      <nz-form-control>
                        <input nz-input [(ngModel)]="disabilitySurvey.typeOfDisabilityNote" [ngModelOptions]="{standalone :true}" [disabled]="!isRequiredNoteDisTypeOfDisability" />
                      </nz-form-control>
                    </nz-form-item>
                  </div>

                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'levelId'" nzRequired #label>9. Mức độ khuyết tật</nz-form-label>
                      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="isCheckValidate && disabilitySurvey.levelId ? '' : 'error'">
                        <asc-autocomplete [ascModel]="LevelControl" (ascModelChange)="changeLevelACFn($event)"
                          placeholder="Chọn mức độ" [getListAC]="getLevelACFn">
                        </asc-autocomplete>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                  </div>
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'supportedEducation'" nzRequired #label>10. Được hỗ trợ giáo dục</nz-form-label>
                      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc">
                        <nz-radio-group [(ngModel)]="disabilitySurvey.supportedEducation" [ngModelOptions]="{standalone :true}">
                          <label nz-radio [nzValue]="false">Không</label>
                          <label nz-radio [nzValue]="true">Có</label>
                        </nz-radio-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="24">
                      <div nz-row [nzGutter]="[24,24]">
                        <div nz-col [nzSpan]="24">
                          <nz-form-label [nzFor]="'educationalStatusId'" nzRequired #label>11. Tình trạng giáo dục</nz-form-label>
                        </div>
                        <div nz-col [nzSpan]="24">
                          <nz-radio-group [ngModel]="disabilitySurvey.educationalStatusId" (ngModelChange)="educationalStatusIdChange($event)" [ngModelOptions]="{standalone :true}">
                            <div nz-row [nzGutter]="[24,24]">
                              <ng-container *ngFor="let status of listStatuses">
                                <div nz-col [nzSpan]="status.isFinished || status.isDroppedOut || status.isStudying ? 12 : 24">
                                  <nz-form-item>
                                    <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                      <label nz-radio [nzValue]="status.id">{{ status.name }}:</label>
                                    </nz-form-label>
                                    <nz-form-control>
                                      <input [disabled]="disabilitySurvey.educationalStatusId !== status.id" *ngIf="status.isStudying"  nz-input [(ngModel)]="disabilitySurvey.studyingClassYear" [ngModelOptions]="{standalone :true}"/>
                                      <input [disabled]="disabilitySurvey.educationalStatusId !== status.id" *ngIf="status.isDroppedOut" nz-input [(ngModel)]="disabilitySurvey.droppedOutClassYear" [ngModelOptions]="{standalone :true}"/>
                                      <asc-autocomplete  [ascModel]="SchoolLevelControl" *ngIf="status.isFinished"
                                        (ascModelChange)="changeSchoolLevel($event)" placeholder="Chọn cấp học..." [disabled]="disabilitySurvey.educationalStatusId !== status.id"
                                        [getListAC]="getSchoolLevelACFn">
                                      </asc-autocomplete>
                                      <input [disabled]="disabilitySurvey.educationalStatusId !== status.id" nz-input *ngIf="status.isNotYetLearned" [(ngModel)]="disabilitySurvey.notYetLearnedNote" [ngModelOptions]="{standalone :true}"/>
                                    </nz-form-control>
                                  </nz-form-item>
                                </div>
                                  <!-- lí do -->
                                <div nz-col [nzSpan]="12" *ngIf="status.isDroppedOut">
                                  <nz-form-item>
                                    <nz-form-label [nzFor]="'field'">
                                      <i class="fas fa-circle"></i>
                                      Lí do
                                    </nz-form-label>
                                    <nz-form-control>
                                      <input nz-input [disabled]="disabilitySurvey.educationalStatusId !== status.id" *ngIf="status.isDroppedOut" [(ngModel)]="disabilitySurvey.droppedOutNote" [ngModelOptions]="{standalone :true}"/>
                                    </nz-form-control>
                                  </nz-form-item>
                                </div>
                                <ng-container *ngIf="status.isStudying">
                                  <div nz-col [nzSpan]="12">
                                    <nz-form-item>
                                      <nz-form-label [nzFor]="'field'">
                                        <i class="fas fa-circle"></i>
                                        Hình thức giáo dục
                                      </nz-form-label>
                                      <nz-form-control>
                                        <asc-autocomplete [ascModel]="disStudyModeControl" (ascModelChange)="changeDisStudyMode($event)" [disabled]="disabilitySurvey.educationalStatusId !== status.id"
                                          placeholder="Chọn hình giáo dục" [getListAC]="getDisStudyModeACFn">
                                        </asc-autocomplete>
                                      </nz-form-control>
                                    </nz-form-item>
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="status.isFinished">
                                  <div nz-col [nzSpan]="12">
                                    <nz-form-item>
                                      <nz-form-label [nzFor]="'field'">
                                        <i class="fas fa-circle"></i>
                                        Trình độ đào tạo
                                      </nz-form-label>
                                      <nz-form-control>
                                        <asc-autocomplete [ascModel]="EducationLevelControl" (ascModelChange)="changeEducationLevel($event)" [disabled]="disabilitySurvey.educationalStatusId !== status.id"
                                        placeholder="Chọn trình độ" [getListAC]="getEducationLevelACFn">
                                      </asc-autocomplete>
                                      </nz-form-control>
                                    </nz-form-item>
                                  </div>
                                </ng-container>
                              </ng-container>
                            </div>
                          </nz-radio-group>
                        </div>
                    </div>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <div nz-row [nzGutter]="[0,24]">
                      <div nz-col [nzSpan]="24">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'listStudentSurveyInterventionStatus'" nzRequired #label>12. Tình trạng can thiệp (đã hoặc đang can thiệp)</nz-form-label>
                          <nz-form-control>
                            <nz-radio-group [ngModel]="disabilitySurvey.interventioned" (ngModelChange)="interventionedChange($event)" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="false">Chưa:</label>
                              <label nz-radio [nzValue]="true">Có:</label>
                            </nz-radio-group>
                          </nz-form-control>
                        </nz-form-item>
                      </div>
                        <ng-container *ngFor="let needOfDisabilities of listNeedOfDisabilities; let i = index">
                          <div nz-col [nzSpan]="8">
                            <nz-form-item>
                            <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                              <label nz-checkbox [ngModel]="needOfDisabilities.checked" (ngModelChange)="needOfDisabilitiesCheckedChange($event, i)" [ngModelOptions]="{standalone: true}" [nzDisabled]="!disabilitySurvey.interventioned">{{ needOfDisabilities.label }}</label>
                            </nz-form-label>
                            </nz-form-item>
                          </div>
                          <div nz-col [nzSpan]="24" *ngIf="needOfDisabilities.isRequiredNote">
                            <nz-form-item>
                              <nz-form-label [nzFor]="'field'">
                                <i class="fas fa-circle"></i>
                                Nhập khi chọn là "khác"
                              </nz-form-label>
                              <nz-form-control>
                                <input nz-input [(ngModel)]="disabilitySurvey.interventionNote" [ngModelOptions]="{standalone :true}" [disabled]="!this.listNeedOfDisabilities[i].checked"/>
                              </nz-form-control>
                            </nz-form-item>
                          </div>
                        </ng-container>
                    </div>
                  </div>
                  <div nz-col [nzSpan]="24" class="flex">
                      <div nz-row [nzGutter]="[24,24]">
                        <div nz-col [nzSpan]="24">
                          <nz-form-label [nzFor]="'employmentStatusId'" nzRequired #label>13. Tình trạng việc làm</nz-form-label>
                        </div>
                        <div nz-col [nzSpan]="24">
                          <nz-radio-group [ngModel]="disabilitySurvey.employmentStatusId" (ngModelChange)="employmentStatusIdChange($event)" [ngModelOptions]="{standalone :true}">
                            <div nz-row [nzGutter]="[24,24]">
                              <ng-container *ngFor="let employmentStatus of listEmploymentStatus">
                                <div nz-col [nzSpan]="employmentStatus.isWorking ? 12 :  24">
                                  <nz-form-item>
                                    <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                      <label nz-radio [nzValue]="employmentStatus.id">{{ employmentStatus.name }}</label>
                                    </nz-form-label>
                                    <nz-form-control>
                                      <input [disabled]="disabilitySurvey.employmentStatusId !== employmentStatus.id" *ngIf="employmentStatus.isNotWorking" nz-input [(ngModel)]="disabilitySurvey.notWorkingNote" [ngModelOptions]="{standalone :true}" />
                                      <input [disabled]="disabilitySurvey.employmentStatusId !== employmentStatus.id" *ngIf="employmentStatus.isQuitJob" nz-input [(ngModel)]="disabilitySurvey.quitJobNote" [ngModelOptions]="{standalone :true}" />
                                      <input [disabled]="disabilitySurvey.employmentStatusId !== employmentStatus.id" *ngIf="employmentStatus.isWorking" nz-input [(ngModel)]="disabilitySurvey.particularJob"[ngModelOptions]="{standalone :true}"/>
                                    </nz-form-control>
                                  </nz-form-item>
                                </div>
                                <div nz-col [nzSpan]="12"  *ngIf="employmentStatus.isWorking">
                                  <nz-form-item>
                                    <nz-form-label [nzFor]="'field'">
                                      <i class="fas fa-circle"></i>
                                      Nhập trung bình tháng
                                    </nz-form-label>
                                    <nz-form-control>
                                      <nz-input-number
                                        type="number"
                                        [disabled]="disabilitySurvey.employmentStatusId !== employmentStatus.id"
                                        [(ngModel)]="disabilitySurvey.averageIncome"
                                        [ngModelOptions]="{standalone :true}"
                                      ></nz-input-number>
                                    </nz-form-control>
                                  </nz-form-item>
                                </div>
                              </ng-container>
                            </div>
                          </nz-radio-group>
                        </div>
                      </div>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'maritalStatusId'" nzRequired #label>14. Tình trạng hôn nhân</nz-form-label>
                      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="isCheckValidate && disabilitySurvey.maritalStatusId ? '' : 'error'">
                        <asc-autocomplete [ascModel]="MaritalStatusControl" (ascModelChange)="changeMaritalStatus($event)"
                          [placeholder]="'Chọn tình trạng'" [getListAC]="getMaritalStatusACFn">
                        </asc-autocomplete>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'caregiverId'" nzRequired #label>15. Đang sống tại</nz-form-label>
                      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="isCheckValidate && disabilitySurvey.caregiverId ? '' : 'error'">
                        <asc-autocomplete [ascModel]="CaregiverControl" (ascModelChange)="changeCaregiver($event)"
                          [placeholder]="'Chọn người chăm sóc'" [getListAC]="getCaregiverACFn">
                      </asc-autocomplete>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'field'">Nhập khi chọn là "khác"</nz-form-label>
                      <nz-form-control>
                        <input nz-input [(ngModel)]="disabilitySurvey.caregiverNote" [ngModelOptions]="{standalone :true}" [disabled]="!isRequiredDisCaregivers"/>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'livingConditionId'" nzRequired #label>16. Điều kiện kinh tế gia đình</nz-form-label>
                      <nz-form-control nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="isCheckValidate && disabilitySurvey.livingConditionId ? '' : 'error'">
                        <asc-autocomplete [ascModel]="LivingConditionsControl" (ascModelChange)="changeLivingConditions($event)"
                        [placeholder]="'Chọn điều kiện'" [getListAC]="getLivingConditionsACFn">
                        </asc-autocomplete>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <!-- Hết row-->
                </div>
              </div>
              <h4 class="title second">
                <nz-form-label [nzFor]="'listStudentSurveyLevelOfDevelopment'" nzRequired [nzNoColon]="true" #label>
                  <h4 class="title second">
                    B. Thông tin về mức độ phát triển
                  </h4>
                </nz-form-label>
              </h4>
              <div class="item-form">
                <div nz-row [nzGutter]="[24,24]">
                  <ng-container *ngFor="let levelOfDevelopmentTypes of listLevelOfDevelopmentTypes; let i = index">
                    <div nz-col [nzSpan]="24">
                      <nz-form-item>
                        <nz-form-label [nzFor]="'field'"> {{ i + 1 }}. {{ levelOfDevelopmentTypes.name }}</nz-form-label>
                        <nz-form-control>
                          <nz-radio-group [(ngModel)]="listlvDv[i]" [ngModelOptions]="{standalone :true}">
                            <ng-container *ngFor="let level of levelOfDevelopmentTypes.levelOfDevelopments">
                              <label class="radioB" nz-radio [nzValue]="level.levelOfDevelopmentId">{{level.name}}</label>
                            </ng-container>
                          </nz-radio-group>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                  </ng-container>
                </div>
              </div>
              <h4 class="title second">
                <nz-form-label [nzFor]="'listStudentSurveyEducationSupport'" [nzNoColon]="true" #label>
                  <h4 class="title second">
                    C. Nhu cầu hỗ trợ, giáo dục
                  </h4>
                </nz-form-label>
              </h4>
              <div class="item-form">
                <div nz-row [nzGutter]="[24,24]">
                  <div nz-col [nzSpan]="24">
                    <div nz-row [nzGutter]="[0,24]" class="w-full">
                      <ng-container *ngFor="let educationalSupports of listEducationalSupports; let i = index">
                        <div nz-col [nzSpan]="24">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                              <label nz-checkbox [ngModel]="educationalSupports.checked" (ngModelChange)="changeOneCheckES($event,i)" [ngModelOptions]="{standalone: true}">{{educationalSupports.name}}</label>
                            </nz-form-label>
                            <!-- sớm -->
                            <nz-form-control *ngIf="educationalSupports.isEarlyIntervention">
                              <asc-autocomplete [ascModel]="ModesOfEducationsControl" (ascModelChange)="changeModesOfEducations($event)" [disabled]="this.listEducationalSupports[i].checked === false"
                                [placeholder]="'Chọn điều kiện'" [getListAC]="getModesOfEducationsACFn">
                              </asc-autocomplete>
                            </nz-form-control>
                            <!-- học nghê -->
                            <nz-form-control *ngIf="educationalSupports.isApprentice">
                                <input nz-input [(ngModel)]="disabilitySurvey.apprenticeNote" [ngModelOptions]="{standalone :true}" [disabled]="this.listEducationalSupports[i].checked === false"/>
                            </nz-form-control>
                            <!-- khác -->
                            <nz-form-control *ngIf="educationalSupports.isRequiredNote">
                                <input nz-input [(ngModel)]="disabilitySurvey.educationalSupportNote" [ngModelOptions]="{standalone :true}" [disabled]="this.listEducationalSupports[i].checked === false"/>
                            </nz-form-control>
                          </nz-form-item>
                        </div>
                        <ng-container *ngIf="educationalSupports.isEducationFacilitiesEquipment">
                          <div nz-col [nzSpan]="24">
                            <nz-form-item>
                              <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                <i class="fas fa-circle"></i>
                                Phương tiện thiết bị giáo dục
                              </nz-form-label>
                              <nz-form-control>
                                <input nz-input [(ngModel)]="disabilitySurvey.educationFacilitiesEquipment" [ngModelOptions]="{standalone :true}" [disabled]="this.listEducationalSupports[i].checked === false"/>
                              </nz-form-control>
                            </nz-form-item>
                          </div>
                          <div nz-col [nzSpan]="24">
                            <nz-form-item>
                              <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                <i class="fas fa-circle"></i>
                                Phương tiện hỗ trợ cá nhân
                              </nz-form-label>
                              <nz-form-control>
                                <input nz-input [(ngModel)]="disabilitySurvey.personalVehicle" [ngModelOptions]="{standalone :true}" [disabled]="this.listEducationalSupports[i].checked === false"/>
                              </nz-form-control>
                            </nz-form-item>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              <h4 class="title second">
                D. Nhận thức chính sách về giáo dục người khuyết tật
              </h4>
              <!-- <nz-form-control [nzSpan]="24" nzErrorTip="Nhập trường thông tin bắt buộc" [nzValidateStatus]="isCheckValidate && disabilitySurvey.understandDisabilityPolicy ? '' : 'error'">
                </nz-form-control> -->
              <div class="item-form">
                <div nz-row [nzGutter]="[24,24]">
                  <div nz-col [nzSpan]="24">
                    <div nz-row [nzGutter]="[0,24]" class="w-full">
                      <div nz-col [nzSpan]="24">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'listStudentSurveyDisabilityPolicy'" nzRequired #label>
                            <b>1. Biết chính sách GD cho người khuyết tật</b>
                          </nz-form-label>
                          <nz-form-control>
                            <nz-radio-group [ngModel]="disabilitySurvey.understandDisabilityPolicy" (ngModelChange)="understandDisabilityPolicyChange($event)" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="false">Chưa</label>
                              <label nz-radio [nzValue]="true">Có</label>
                            </nz-radio-group>
                          </nz-form-control>
                        </nz-form-item>
                      </div>
                      <ng-container *ngFor="let disabilityPolicy of listDisabilityPolicy; let i = index">
                        <div nz-col [nzSpan]="12">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                              <label [nzTooltipTitle]="disabilityPolicy.name" nz-tooltip nz-checkbox [ngModel]="disabilityPolicy.checked" (ngModelChange)="disabilityPolicyCheckedChange($event, i)" [ngModelOptions]="{standalone :true}" [nzDisabled]="!disabilitySurvey.understandDisabilityPolicy">{{ disabilityPolicy.name }}</label>
                            </nz-form-label>
                          </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="24" *ngIf="disabilityPolicy.isRequiredNote">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'">
                              <i class="fas fa-circle"></i>
                              Nhập khi chọn loại "khác"
                            </nz-form-label>
                            <nz-form-control>
                              <input nz-input [(ngModel)]="disabilitySurvey.disabilityPolicyNote" [ngModelOptions]="{standalone :true}" [disabled]="!this.listDisabilityPolicy[i].checked"/>
                            </nz-form-control>
                          </nz-form-item>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <div nz-row [nzGutter]="[0,24]" class="w-full">
                      <div nz-col [nzSpan]="24">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'listStudentSurveyInformationSource'" nzRequired #label>
                            Tiếp nhận thông tin về các chính sách từ nguồn
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <ng-container *ngFor="let informationSources of listInformationSources; let i = index">
                        <div nz-col [nzSpan]="12">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                              <label nz-checkbox [ngModel]="informationSources.checked" (ngModelChange)="changeOneCheckInformationSources($event,i)" [ngModelOptions]="{standalone :true}">{{ informationSources.name }}</label>
                            </nz-form-label>
                          </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="12" *ngIf="informationSources.isRequiredNote">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'">
                              <i class="fas fa-circle"></i>
                              Nhập khi chọn loại "khác"
                            </nz-form-label>
                            <nz-form-control>
                              <input nz-input [(ngModel)]="disabilitySurvey.informationSourceNote" [ngModelOptions]="{standalone :true}" [disabled]="!this.listInformationSources[i].checked"/>
                            </nz-form-control>
                          </nz-form-item>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <div nz-row>
                      <div nz-col [nzSpan]="24">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'">
                            <b>2. Sự phối hợp của cộng đồng trong thực hiện chính sách giáo dục người khuyết tật</b>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="24">
                        <nz-radio-group [(ngModel)]="disabilitySurvey.communityCoordination" [ngModelOptions]="{standalone: true}">
                          <div nz-row>
                            <div nz-col [nzSpan]="24">
                              <div nz-col [nzSpan]="24">
                                <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                  <label nz-radio [nzValue]="false">Không</label>
                                </nz-form-label>
                              </div>
                              <div nz-col [nzSpan]="24" class="flex">
                                <div>
                                  <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                    <label nz-radio [nzValue]="true">Có (Cụ thể):</label>
                                  </nz-form-label>
                                </div>
                                <nz-radio-group [(ngModel)]="disabilitySurvey.communityCoordinationId" [ngModelOptions]="{standalone: true}">
                                  <div nz-row>
                                    <ng-container *ngFor="let publicCommunityCoordinations of listPublicCommunityCoordinations">
                                      <div nz-col [nzSpan]="8">
                                          <nz-form-item>
                                            <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                              <label nz-radio [nzValue]="publicCommunityCoordinations.value" [nzDisabled]="!disabilitySurvey.communityCoordination">{{ publicCommunityCoordinations.name }}</label>
                                            </nz-form-label>
                                          </nz-form-item>
                                      </div>
                                    </ng-container>
                                  </div>
                                </nz-radio-group>
                              </div>
                            </div>
                          </div>
                        </nz-radio-group>
                      </div>
                    </div>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <div nz-row>
                      <div nz-col [nzSpan]="24">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'">
                            <b>3. Sự phối hợp của chính quyền và ban ngành địa phương</b>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="24">
                        <nz-radio-group [(ngModel)]="disabilitySurvey.localGovernmentCoordination" [ngModelOptions]="{standalone: true}">
                          <div nz-row>
                            <div nz-col [nzSpan]="24">
                              <div nz-col [nzSpan]="24">
                                <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                  <label nz-radio [nzValue]="false">Không</label>
                                </nz-form-label>
                              </div>
                              <div nz-col [nzSpan]="24" class="flex">
                                <div>
                                  <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                    <label nz-radio [nzValue]="true">Có (Cụ thể):</label>
                                  </nz-form-label>
                                </div>
                                <nz-radio-group [(ngModel)]="disabilitySurvey.localGovernmentCoordinationId" [ngModelOptions]="{standalone: true}">
                                  <div nz-row>
                                    <ng-container *ngFor="let localGovernmentCoordinations of listLocalGovernmentCoordinations">
                                      <div nz-col [nzSpan]="8">
                                          <nz-form-item>
                                            <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                              <label nz-radio [nzValue]="localGovernmentCoordinations.value" [nzDisabled]="!disabilitySurvey.localGovernmentCoordination">{{ localGovernmentCoordinations.name }}</label>
                                            </nz-form-label>
                                          </nz-form-item>
                                      </div>
                                    </ng-container>
                                  </div>
                                </nz-radio-group>
                              </div>
                            </div>
                          </div>
                        </nz-radio-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h4 class="title second">
                E. Thông tin gia đình
              </h4>
              <div class="item-form">
                <div nz-row [nzGutter]="[24,24]">
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'field'">
                        <b>1. Thông tin nguời giám hộ</b>
                      </nz-form-label>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label >1. Họ tên người giám hộ</nz-form-label>
                      <nz-form-control>
                        <input nz-input [(ngModel)]="disabilitySurvey.tutorName" [ngModelOptions]="{standalone :true}"/>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label >2. Giới tính</nz-form-label>
                        <nz-form-control>
                          <nz-radio-group [(ngModel)]="disabilitySurvey.tutorGender" [ngModelOptions]="{standalone :true}">
                            <label nz-radio [nzValue]="1">Nam</label>
                            <label nz-radio [nzValue]="0">Nữ</label>
                          </nz-radio-group>
                        </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label >3. Dân tộc</nz-form-label>
                      <nz-form-control>
                        <asc-autocomplete [ascModel]="TutorFolkControl" (ascModelChange)="changeTutorFolk($event)" [placeholder]="'Chọn dân tộc'" [getListAC]="getFolkACFn">
                        </asc-autocomplete>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label >4. Nghề nghiệp</nz-form-label>
                      <nz-form-control>
                        <input nz-input [(ngModel)]="disabilitySurvey.tutorCareer" [ngModelOptions]="{standalone :true}"/>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label >5. Mối quan hệ với người khuyết tật</nz-form-label>
                      <nz-form-control>
                        <asc-autocomplete [ascModel]="RelationshipControl" (ascModelChange)="changeRelationship($event)" [placeholder]="'Chọn mối quan hệ'" [getListAC]="getRelationshipACFn">
                        </asc-autocomplete>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label>6. Trình độ đào tạo</nz-form-label>
                      <nz-form-control>
                        <asc-autocomplete [ascModel]="tutorEducationLevelControl" (ascModelChange)="changeTutorEducationLevel($event)"
                          placeholder="Chọn trình độ" [getListAC]="getTutorEducationLevelACFn">
                        </asc-autocomplete>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="12">
                    <nz-form-item>
                      <nz-form-label>Nhập khi chọn là "khác"</nz-form-label>
                      <nz-form-control>
                        <input nz-input [(ngModel)]="disabilitySurvey.tutorEducationLevelOther" [ngModelOptions]="{standalone :true}" [disabled]="!isRequiredTutorEducationLevel"/>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </div>
              <h4 class="title second">
                F. Nhận thức chính sách giáo dục người khuyết tật
              </h4>
              <div class="item-form">
                <div nz-row [nzGutter]="[24,24]">
                  <div nz-col [nzSpan]="24">
                    <div nz-row [nzGutter]="[0,24]" class="w-full">
                      <div nz-col [nzSpan]="24">
                        <nz-form-item>
                          <nz-form-label #label>
                            <b>1. Biết chính sách GD cho người khuyết tật</b>
                          </nz-form-label>
                          <nz-form-control>
                            <nz-radio-group [ngModel]="disabilitySurvey.tutorUnderstandDisabilityPolicy" (ngModelChange)="tutorUnderstandDisabilityPolicyChange($event)" [ngModelOptions]="{standalone :true}">
                              <label nz-radio [nzValue]="false">Không</label>
                              <label nz-radio [nzValue]="true">Có</label>
                            </nz-radio-group>
                          </nz-form-control>
                        </nz-form-item>
                      </div>
                      <ng-container *ngFor="let disabilityPolicy of listTutorDisabilityPolicy; let i = index">
                        <div nz-col [nzSpan]="12">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                              <label [nzTooltipTitle]="disabilityPolicy.name" nz-tooltip nz-checkbox [ngModel]="disabilityPolicy.checked" (ngModelChange)="tutorDisabilityPolicyCheckedChange($event, i)" [ngModelOptions]="{standalone :true}" [nzDisabled]="!disabilitySurvey.tutorUnderstandDisabilityPolicy">{{ disabilityPolicy.name }}</label>
                            </nz-form-label>
                          </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="24" *ngIf="disabilityPolicy.isRequiredNote">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'">
                              <i class="fas fa-circle"></i>
                              Nhập khi chọn loại "khác"
                            </nz-form-label>
                            <nz-form-control>
                              <input nz-input [(ngModel)]="disabilitySurvey.tutorDisabilityPolicyNote" [ngModelOptions]="{standalone :true}" [disabled]="!this.listTutorDisabilityPolicy[i].checked"/>
                            </nz-form-control>
                          </nz-form-item>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <div nz-row [nzGutter]="[0,24]" class="w-full">
                      <div nz-col [nzSpan]="24">
                        <nz-form-item>
                          <nz-form-label #label>
                            Tiếp nhận thông tin về các chính sách từ nguồn
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <ng-container *ngFor="let informationSources of listTutorInformationSources; let i = index">
                        <div nz-col [nzSpan]="12">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                              <label nz-checkbox [ngModel]="informationSources.checked" (ngModelChange)="changeOneCheckTutorInformationSources($event,i)" [ngModelOptions]="{standalone :true}">{{ informationSources.name }}</label>
                            </nz-form-label>
                          </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="12" *ngIf="informationSources.isRequiredNote">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'">
                              <i class="fas fa-circle"></i>
                              Nhập khi chọn loại "khác"
                            </nz-form-label>
                            <nz-form-control>
                              <input nz-input [(ngModel)]="disabilitySurvey.tutorInformationSourceNote" [ngModelOptions]="{standalone :true}" [disabled]="!this.listTutorInformationSources[i].checked"/>
                            </nz-form-control>
                          </nz-form-item>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <div nz-row>
                      <div nz-col [nzSpan]="24">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'">
                            <b>2. Sự phối hợp của cộng đồng trong thực hiện chính sách giáo dục người khuyết tật</b>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="24">
                        <nz-radio-group [(ngModel)]="disabilitySurvey.tutorCommunityCoordination" [ngModelOptions]="{standalone: true}">
                          <div nz-row>
                            <div nz-col [nzSpan]="24">
                              <div nz-col [nzSpan]="24">
                                <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                  <label nz-radio [nzValue]="false">Không</label>
                                </nz-form-label>
                              </div>
                              <div nz-col [nzSpan]="24" class="flex">
                                <div>
                                  <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                    <label nz-radio [nzValue]="true">Có (Cụ thể):</label>
                                  </nz-form-label>
                                </div>
                                <nz-radio-group [(ngModel)]="disabilitySurvey.tutorCommunityCoordinationId" [ngModelOptions]="{standalone: true}">
                                  <div nz-row>
                                    <ng-container *ngFor="let publicCommunityCoordinations of listPublicTutorCommunityCoordinations">
                                      <div nz-col [nzSpan]="8">
                                          <nz-form-item>
                                            <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                              <label nz-radio [nzValue]="publicCommunityCoordinations.value" [nzDisabled]="!disabilitySurvey.tutorCommunityCoordination">{{ publicCommunityCoordinations.name }}</label>
                                            </nz-form-label>
                                          </nz-form-item>
                                      </div>
                                    </ng-container>
                                  </div>
                                </nz-radio-group>
                              </div>
                            </div>
                          </div>
                        </nz-radio-group>
                      </div>
                    </div>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <div nz-row>
                      <div nz-col [nzSpan]="24">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'">
                            <b>3. Sự phối hợp của chính quyền và ban ngành địa phương</b>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="24">
                        <nz-radio-group [(ngModel)]="disabilitySurvey.tutorLocalGovernmentCoordination" [ngModelOptions]="{standalone: true}">
                          <div nz-row>
                            <div nz-col [nzSpan]="24">
                              <div nz-col [nzSpan]="24">
                                <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                  <label nz-radio [nzValue]="false">Không</label>
                                </nz-form-label>
                              </div>
                              <div nz-col [nzSpan]="24" class="flex">
                                <div>
                                  <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                    <label nz-radio [nzValue]="true">Có (Cụ thể):</label>
                                  </nz-form-label>
                                </div>
                                <nz-radio-group [(ngModel)]="disabilitySurvey.tutorLocalGovernmentCoordinationId" [ngModelOptions]="{standalone: true}">
                                  <div nz-row>
                                    <ng-container *ngFor="let localGovernmentCoordinations of listTutorLocalGovernmentCoordinations">
                                      <div nz-col [nzSpan]="8">
                                          <nz-form-item>
                                            <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                              <label nz-radio [nzValue]="localGovernmentCoordinations.value" [nzDisabled]="!disabilitySurvey.tutorLocalGovernmentCoordination">{{ localGovernmentCoordinations.name }}</label>
                                            </nz-form-label>
                                          </nz-form-item>
                                      </div>
                                    </ng-container>
                                  </div>
                                </nz-radio-group>
                              </div>
                            </div>
                          </div>
                        </nz-radio-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h4 class="title second">
                G. Kiến thức, kỹ năng, chăm sóc, hỗ trợ người khuyết tật
              </h4>
              <div class="item-form">
                <div nz-row [nzGutter]="[24,24]">
                  <div nz-col [nzSpan]="24">
                    <nz-form-item>
                      <nz-form-label [nzFor]="'field'" [nzSpan]="24">
                        <b>1. Ông/bà đã được bồi dưỡng về kỹ năng chăm sóc giáo dục và hỗ trợ người khuyết tật chưa?</b>
                      </nz-form-label>
                      <nz-form-control [nzSpan]="24">
                        <nz-radio-group [(ngModel)]="disabilitySurvey.tutorUnfostered" [ngModelOptions]="{standalone :true}">
                          <div nz-row [nzGutter]="[24,12]">
                            <div nz-col [nzSpan]="24">
                              <nz-form-label [nzFor]="'field'" [nzSpan]="24">
                                <label nz-radio [nzValue]="false">Chưa</label>
                              </nz-form-label>
                            </div>
                            <div nz-col [nzSpan]="24" class="flex">
                              <nz-form-label [nzFor]="'field'">
                                <label nz-radio [nzValue]="true">Có</label>
                              </nz-form-label>
                              <div nz-row [nzGutter]="[24,24]" class="w-full">
                                <div nz-col [nzSpan]="24" *ngFor="let tutorTrainingAndRetrainingType of listTutorTrainingAndRetrainingType; let i = index">
                                  <nz-form-item>
                                    <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                      <label
                                        nz-checkbox
                                        [nzTooltipTitle]="tutorTrainingAndRetrainingType.name"
                                        nz-tooltip
                                        nz-checkbox
                                        [ngModel]="tutorTrainingAndRetrainingType.checked"
                                        (ngModelChange)="tutorTrainingAndRetrainingTypeChange($event, i)"
                                        [ngModelOptions]="{standalone :true}"
                                        [nzDisabled]="!disabilitySurvey.tutorUnfostered"
                                        >
                                        {{ tutorTrainingAndRetrainingType.name }}
                                      </label>
                                    </nz-form-label>
                                    <nz-form-control>
                                      <input nz-input [(ngModel)]="tutorTrainingAndRetrainingType.note" [ngModelOptions]="{standalone :true}" [disabled]="!listTutorTrainingAndRetrainingType[i].checked">
                                    </nz-form-control>
                                  </nz-form-item>
                                </div>
                              </div>
                            </div>
                            <div nz-col [nzSpan]="24">
                              <nz-form-label [nzFor]="'field'" class="italic">
                                Nội dung đã được đào tạo và bồi dưỡng
                              </nz-form-label>
                            </div>
                            <ng-container *ngFor="let tutorTrainingAndRetraining of listTutorTrainingAndRetraining; let i = index">
                              <div nz-col [nzSpan]="12">
                                <nz-form-item>
                                  <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                    <label nz-checkbox [ngModel]="tutorTrainingAndRetraining.checked" (ngModelChange)="tutorTrainingAndRetrainingChange($event,i)" [ngModelOptions]="{standalone :true}">{{ tutorTrainingAndRetraining.name }}</label>
                                  </nz-form-label>
                                </nz-form-item>
                              </div>
                              <div nz-col [nzSpan]="12" *ngIf="tutorTrainingAndRetraining.isRequiredNote">
                                <nz-form-item>
                                  <nz-form-label [nzFor]="'field'">
                                    <i class="fas fa-circle"></i>
                                    Nhập khi chọn loại "khác"
                                  </nz-form-label>
                                  <nz-form-control>
                                    <input nz-input [(ngModel)]="disabilitySurvey.tutorTrainingAndRetrainingNote" [ngModelOptions]="{standalone :true}" [disabled]="!this.listTutorTrainingAndRetraining[i].checked"/>
                                  </nz-form-control>
                                </nz-form-item>
                              </div>
                            </ng-container>
                          </div>
                        </nz-radio-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col [nzSpan]="24">
                    <div nz-row [nzGutter]="[24,24]">
                      <div nz-col [nzSpan]="24">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'">
                            <b>2. Đào tạo và bồi dưỡng về kỹ năng chăm sóc người khuyết tật</b>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" class="text-center">
                            <b>Loại kỹ năng</b>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" class="text-center">
                            <b>Đã được đào tạo bồi dưỡng</b>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="8">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'" class="text-center">
                            <b>Nhu cầu được đào tạo bồi dưỡng</b>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <ng-container *ngFor="let skillType of listSkillTypes; let i = index">
                        <div nz-col [nzSpan]="8">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'" class="text-center">
                              {{ i+1 }}. {{ skillType.name }}
                            </nz-form-label>
                          </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="8">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'" class="text-center" nzNoColon="true">
                              <nz-radio-group [(ngModel)]="skillType.hasBeenTrained" [ngModelOptions]="{standalone :true}">
                                <label nz-radio [nzValue]="true">Có</label>
                                <label nz-radio [nzValue]="false">Không</label>
                              </nz-radio-group>
                            </nz-form-label>
                          </nz-form-item>
                        </div>
                        <div nz-col [nzSpan]="8">
                          <nz-form-item>
                            <nz-form-label [nzFor]="'field'" class="text-center" nzNoColon="true">
                              <nz-radio-group [(ngModel)]="skillType.isDemand" [ngModelOptions]="{standalone :true}">
                                <label nz-radio [nzValue]="true">Có</label>
                                <label nz-radio [nzValue]="false">Không</label>
                              </nz-radio-group>
                            </nz-form-label>
                          </nz-form-item>
                        </div>
                      </ng-container>
                      <div nz-col [nzSpan]="24">
                        <nz-form-item>
                          <nz-form-label [nzFor]="'field'">
                            <b>3. Mong muốn của Ông/bà đối với người khuyết tật</b>
                          </nz-form-label>
                        </nz-form-item>
                      </div>
                      <div nz-col [nzSpan]="24">
                        <div nz-row [nzGutter]="[24,24]">
                          <div nz-col [nzSpan]="24">
                            <div nz-row [nzGutter]="[0,24]" class="w-full">
                              <ng-container *ngFor="let educationalSupports of listTutorEducationalSupports; let i = index">
                                <div nz-col [nzSpan]="24">
                                  <nz-form-item>
                                    <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                      <label nz-checkbox [ngModel]="educationalSupports.checked" (ngModelChange)="changeOneCheckTutorES($event,i)" [ngModelOptions]="{standalone: true}">{{educationalSupports.name}}</label>
                                    </nz-form-label>
                                    <!-- sớm -->
                                    <nz-form-control *ngIf="educationalSupports.isEarlyIntervention">
                                      <asc-autocomplete [ascModel]="TutorModesOfEducationsControl" (ascModelChange)="changeTutorModesOfEducations($event)" [disabled]="this.listTutorEducationalSupports[i].checked === false"
                                        [placeholder]="'Chọn điều kiện'" [getListAC]="getTutorModesOfEducationsACFn">
                                      </asc-autocomplete>
                                    </nz-form-control>
                                    <!-- học nghê -->
                                    <nz-form-control *ngIf="educationalSupports.isApprentice">
                                        <input nz-input [(ngModel)]="disabilitySurvey.tutorApprenticeNote" [ngModelOptions]="{standalone :true}" [disabled]="this.listTutorEducationalSupports[i].checked === false"/>
                                    </nz-form-control>
                                    <!-- khác -->
                                    <nz-form-control *ngIf="educationalSupports.isRequiredNote">
                                        <input nz-input [(ngModel)]="disabilitySurvey.tutorEducationalSupportNote" [ngModelOptions]="{standalone :true}" [disabled]="this.listTutorEducationalSupports[i].checked === false"/>
                                    </nz-form-control>
                                  </nz-form-item>
                                </div>
                                <ng-container *ngIf="educationalSupports.isEducationFacilitiesEquipment">
                                  <div nz-col [nzSpan]="24">
                                    <nz-form-item>
                                      <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                        <i class="fas fa-circle"></i>
                                        Phương tiện thiết bị giáo dục
                                      </nz-form-label>
                                      <nz-form-control>
                                        <input nz-input [(ngModel)]="disabilitySurvey.tutorEducationFacilitiesEquipment " [ngModelOptions]="{standalone :true}" [disabled]="this.listTutorEducationalSupports[i].checked === false"/>
                                      </nz-form-control>
                                    </nz-form-item>
                                  </div>
                                  <div nz-col [nzSpan]="24">
                                    <nz-form-item>
                                      <nz-form-label [nzFor]="'field'" [nzNoColon]="true">
                                        <i class="fas fa-circle"></i>
                                        Phương tiện hỗ trợ cá nhân
                                      </nz-form-label>
                                      <nz-form-control>
                                        <input nz-input [(ngModel)]="disabilitySurvey.tutorPersonalVehicle" [ngModelOptions]="{standalone :true}" [disabled]="this.listTutorEducationalSupports[i].checked === false"/>
                                      </nz-form-control>
                                    </nz-form-item>
                                  </div>
                                </ng-container>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btng-end">
                <button nz-button nzType="primary" [disabled]="submitted" (click)="update()" type="submit">Hoàn thành</button>&nbsp;
                <button nz-button [routerLink]="['/',  'project']">Đóng</button>
              </div>
          </div>
      </nz-card>
    </div>
    <div nz-col nzSm="2" nzMd="2" nzLg="2" nzXl="3">
    </div>
  </div>
</form>
